import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import Carousel from '../../components/Carousel';
import DefaultCard from '../../components/DefaultCard';
import FingerTipsLinks from '../../components/FingertipsLinks/FingertipsLinks';
import {
  HwDashboardProvider,
  HwDashboardStore,
} from '../../providers/hwDashboard';
import {
  COBRA_BENEFITS_ENROLLMENT_ROUTE,
  HEALTH_SUMMARY,
  LIFE_EVENTS_ROUTE,
  PAYMENT_INFO_ROUTE,
  PROFILE_ROUTE,
} from '../../routes/types';
import HealthSavingsAndSpending from '../widgets/dashboards/HealthSavingsAndSpending';
import HealthSnapshot from '../widgets/dashboards/HealthSnapshot';

const healthSnapshotLinksData = [
  {
    linkHeader: 'More Details',
    route: `${HEALTH_SUMMARY}`,
  },

  {
    linkHeader: 'Change Coverage',
    route: `${LIFE_EVENTS_ROUTE}`,
  },

  {
    linkHeader: 'Payment Information',
    route: `${PAYMENT_INFO_ROUTE}`,
  },

  {
    linkHeader: 'Beneficiaries',
    route: `${PROFILE_ROUTE.slice(0, 9)}beneficiaries`,
  },

  {
    linkHeader: 'Family Members',
    route: `${PROFILE_ROUTE.slice(0, 9)}familymembers`,
  },
];

const dataCompanyContributions = {
  grid: {
    padding: {
      left: 0,
    },
  },
  legend: {
    show: false,
  },

  dataLabels: {
    enabled: false,
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        grid: {
          padding: {
            left: 0,
          },
        },
        legend: {
          show: false,
        },
        title: {},
      },
    },
  ],
  colors: ['#074CBC', '#F48462', '#07B4A0', '#EEA968', '#92E3A9'],
  series: [95072, 15905, 14791, 6500, 0],
  labels: [
    'Compensation',
    'Health and Welfare',
    'Retirement',
    'Equity',
    'Other Benefits',
  ],

  tooltip: {
    enabled: false,
  },

  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          name: {
            offsetY: 10,
          },
          total: {
            show: true,
            showAlways: true,
            fontSize: '18px',
            fontFamily: 'Roboto, Arial, sans-serif',
            fontWeight: 500,
            label: `$132,268`,
            formatter: function (a: any) {
              return '';
            },
          },
        },
      },
    },
  },
};

const accruedPensionData = [
  {
    title: 'HSA',
    subtitle: 'Health Saving Account',
    priceDescription: 'Total Value',
    balance: 36380.81,
  },

  {
    title: 'FSA',
    subtitle: 'Flexible Spendings Account',
    priceDescription: 'Available',
    balance: 399.75,
  },

  {
    title: 'HRA',
    subtitle: 'Health Reimbursement Arrangement',
    priceDescription: 'Available',
    balance: 2339.18,
  },
];

const HwCobraDashboardView = () => {
  const { fingertipLinks, companiesMessages, coveredFamilyMembers } =
    useContext(HwDashboardStore) || {};
  const navigate = useNavigate();
  const date = new Date();

  return (
    <Container className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}>
      <Row>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-7">
          <DefaultCard
            className="h-100 flex-column flex-sm-row "
            variant="blue-motif"
            leftHeading={
              <div className="text-sm-20-lg-32">COBRA Benefit Information</div>
            }
            leftSubheading={
              <div className="text-sm-12-lg-14 fw-light mb-7">
                {`You are eligible to enroll in COBRA continuation coverage for yourself and your eligible dependents.`}
              </div>
            }
            button={
              <Button
                className="align-self-end"
                variant="primary-shadow"
                size="sm"
                onClick={() => navigate(COBRA_BENEFITS_ENROLLMENT_ROUTE)}
              >
                Enroll Now
              </Button>
            }
          />
        </Col>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-5">
          <DefaultCard
            className="flex-column"
            variant="blue"
            leftHeading={<div className="text-sm-20-lg-32">Current Events</div>}
            leftSubheading={
              <Container className="p-0 mb-7">
                <Row className="text-sm-12-lg-14 p-0">
                  <Col className=" text-nowrap col-12 fw-light">
                    There are currently no events.
                  </Col>
                </Row>
              </Container>
            }
          />
        </Col>
      </Row>

      <Row className="d-flex justify-content-between">
        <Col
          className={'d-flex flex-column pt-lg-8 col-12 col-lg-7 mt-10 mt-lg-8'}
        >
          <HealthSnapshot
            isWaived={true}
            coveredFamilyMembers={coveredFamilyMembers}
            linksData={healthSnapshotLinksData}
          />
        </Col>
        <Col className="pe-lg-0 mt-12 mt-lg-8 pt-lg-8 col-12 col-lg-5">
          <FingerTipsLinks data={fingertipLinks} className="p-0 pe-5" />
        </Col>
      </Row>

      <Row className="m-0 d-flex justify-content-between">
        <Col
          className={
            'm-0 p-0 d-flex flex-column pt-lg-6 col-12 col-lg-6 mt-10 mt-lg-6 pe-lg-4'
          }
        >
          <HealthSavingsAndSpending accruedPensionData={accruedPensionData} />
        </Col>
      </Row>

      <Row className="m-0 mt-12 p-0">
        <Carousel data={companiesMessages} />
      </Row>
    </Container>
  );
};

const HwCobraDashboard = () => {
  return (
    <HwDashboardProvider>
      <HwCobraDashboardView />
    </HwDashboardProvider>
  );
};

export default HwCobraDashboard;
